import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Target, Shield, Award } from 'lucide-react';

const AboutSection = ({ onOpenModal }) => {
  return (
    <section id="about" className="md:py-20 py-4 bg-gradient-to-br from-navy-900 via-navy-800 to-navy-900">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 md:gap-12 gap-6 items-center">
          {/* Image Side */}
          <div className="relative animate-fade-in">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl hover-zoom">
              <img
                src="https://images.unsplash.com/photo-1758518731706-be5d5230e5a5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMHRlYW0lMjBzdHJhdGVneSUyMG1lZXRpbmclMjBjb3Jwb3JhdGV8ZW58MHx8fHwxNzczOTQwMDc2fDA&ixlib=rb-4.1.0&q=85&w=800"
                alt="Team collaborating on brand strategy"
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-navy-900/50 to-transparent"></div>
            </div>
          </div>

          {/* Content Side */}
          <div className="space-y-6 animate-slide-up">
            <div className="inline-block bg-navy-700 px-4 py-2 rounded-full">
              <span className="text-gold-400 font-semibold">ABOUT US</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-100 leading-tight">
              Built for Founders{' '}
              <span className="bg-brand-gradient bg-clip-text text-transparent">
                Who Think Ahead
              </span>
            </h2>
            <p className="text-lg text-gray-300 leading-relaxed">
              Trademark Nexor exists because brand protection shouldn't require a corporate legal budget. We've built a streamlined system that gives startups, small businesses, and growing companies the same level of IP defense that Fortune 500 firms rely on.
            </p>
            <p className="text-lg text-gray-300 leading-relaxed">
              From your first trademark search to ongoing monitoring and enforcement, our team handles the complexity so you can stay focused on building what matters most.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-4">
              <div className="flex items-start space-x-3 group hover:translate-x-2 transition-transform">
                <div className="bg-navy-700 p-2 rounded-lg group-hover:scale-110 transition-transform">
                  <Target className="text-brand-primary icon-bounce" size={24} />
                </div>
                <div>
                  <h4 className="font-bold text-gray-100">Legal-Grade Team</h4>
                  <p className="text-gray-300 text-sm">Licensed professionals with IP specialization</p>
                </div>
              </div>
              <div className="flex items-start space-x-3 group hover:translate-x-2 transition-transform">
                <div className="bg-navy-700 p-2 rounded-lg group-hover:scale-110 transition-transform">
                  <Shield className="text-brand-primary icon-bounce" size={24} />
                </div>
                <div>
                  <h4 className="font-bold text-gray-100">End-to-End Coverage</h4>
                  <p className="text-gray-300 text-sm">From search through registration and monitoring</p>
                </div>
              </div>
            </div>

            <Button
              size="lg"
              className="bg-brand-gradient text-white hover:opacity-90 group mt-6 shadow-lg hover:shadow-xl transition-all font-bold text-lg px-8 py-6"
              onClick={onOpenModal}
            >
              Get Started Now
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={24} />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;